/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bi_Dashboard_Authoring_Restrict_Toggle_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update dashboard authoring setting." |
*
* @param {Bi_Dashboard_Authoring_Restrict_Toggle_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bi_dashboard_authoring_restrict_toggle_error = /** @type {((inputs?: Bi_Dashboard_Authoring_Restrict_Toggle_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bi_Dashboard_Authoring_Restrict_Toggle_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dashboard-Einstellung konnte nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Failed to update dashboard authoring setting.")
});